import { tw } from '@/utils/tw';
import BaseBlipTheme from 'base/components/Blip/theme';

const Blip = tw.theme({
  extend: BaseBlipTheme,
  base: `bg-primary-700 before:bg-primary-700 after:bg-primary-700`,
});

export default Blip;
